module.exports = __webpack_public_path__ + "img/document-hover.dc4493c7.svg";